/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FastIlsInfo } from '../../models/fast-ils-info';

export interface IlsControllerFindFastIlsById$Params {
  ilsId: string;
}

export function ilsControllerFindFastIlsById(http: HttpClient, rootUrl: string, params: IlsControllerFindFastIlsById$Params, context?: HttpContext): Observable<StrictHttpResponse<FastIlsInfo>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerFindFastIlsById.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FastIlsInfo>;
    })
  );
}

ilsControllerFindFastIlsById.PATH = '/ils/{ilsId}/findFastIlsById';
